import React, { Fragment } from "react";
import Header from "../components/Header";
import DocDeptWise from "../templates/DocDetails/DocDeptWise";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import SEO from '../components/SEO';

const DeptDoctors = () => {
  return (
    <Fragment>
      <Header />
      <DocDeptWise />
      <SEO/>
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default DeptDoctors;
